import { useState } from "react";
import { useTranslation } from "react-i18next";

const TaskSortComponent = ({currentPage, perPage, request, sendSortTaskDataFromChild}) => {
    const { t } = useTranslation();
    const [showSort, setShowSort] = useState(false);
    const [sortType, setSortType] = useState("");
    const [sortField, setSortField] = useState("");
    const [sortName, setSortName] = useState("");
    const sortTypesList = [
        {
            "name" : "from date - ascending",
            "field" : "fromDate",
            "type" : "asc"
        },
        {
            "name" : "from date - descending",
            "field" : "fromDate",
            "type" : "desc"
        },
        {
            "name" : "to date - ascending",
            "field" : "toDate",
            "type" : "asc"
        },
        {
            "name" : "to date - descending",
            "field" : "toDate",
            "type" : "desc"
        },
        {
            "name" : "name - ascending",
            "field" : "name",
            "type" : "asc"
        },
        {
            "name" : "name - descending",
            "field" : "name",
            "type" : "desc"
        },
    ];

    const handleSortType = (e, data) => {
        e.preventDefault();
        setShowSort(!showSort);
        setSortType(data.type);
        setSortField(data.field);
        setSortName(data.name);

        if (data.field === "fromDate") {
            request.sortByFromDateASC = (data.type === 'asc');
            request.sortByFromDateDESC = (data.type === 'desc');
        } else if (data.field === "name") {
            request.sortByNameASC = (data.type === 'asc');
            request.sortByNameDESC = (data.type === 'desc');
        } else if (data.field === "toDate") {
            request.sortByToDateASC = (data.type === 'asc');
            request.sortByToDateDESC = (data.type === 'desc');
        }
        request.paging_offset = 1;
        sendSortTaskDataFromChild(request);
    };
    const handleShowSort = (e) => {
        e.preventDefault();
        setShowSort(!showSort);
    };
    return (
        <div className="relative"> 
            <div className="flex w-fit items-center cursor-pointer bg-black-300 rounded-lg py-2 px-3" onClick={(e) => handleShowSort(e)}>
                <img  src="../../../assets/icons/table/sort.svg" alt="sort" />
                <div className="hidden sm:block ml-2 text-blue-normal font-semibold text-sm capitalize">{ t('sort')}</div>
            </div>
            {
                showSort 
                ?
                    <ul className="z-20 py-3 bg-white top-8 absolute right-0 border border-white shadow-md rounded-[10px] w-44 text-left">
                        {sortTypesList.map((value, index) => (
                            <li key={index} onClick={(e) => handleSortType((e), value)} className={(sortName === value.name ? "bg-action-hover" : "bg-white") + " hover:bg-action-hover py-2 px-4 block whitespace-no-wrap cursor-pointer capitalize text-xs"}>{ t(value.name)}</li>
                        ))}
                    </ul>
                : null
            }
        </div>
    )
}

export default TaskSortComponent;